/* eslint-disable react-hooks-ext/exhaustive-deps -- TODO(react-hooks): 3 hook(s) need dependency review; fix each and remove this directive */
import { useTranslation } from "@i18n";
import { untranslated, type TranslatedString } from "@i18n";
import { startTransition, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  formCategoryObject,
  getPresetSectionsObject,
} from "@Features/portal-settings/components/PortalSetings/Configuration/FormsAndFields/constants";
import { optionsViewType } from "@Features/portal-settings/components/PortalSetings/Configuration/FormsAndFields/FormTemplate/constant.helper";
import { formCategories } from "@Helpers";
import {
  addValidationToForms,
  checkMandatoryFields,
  formSectionType,
  getSectionPermission,
  getUserPermissionForForm,
} from "./constants";
import _ from "lodash";
import { PLATFORM, TOAST_TYPE_ERROR, TOAST_TYPE_SUCCESS, TOAST_TYPE_WARNING } from "@Services/constants";
import { SignTypeValues } from "@CubeComponents/constants";
import { showToastNotification } from "@Reducers/toastSlice";
import useFormValidator from "../FormValidation/useFormValidator";
import { getContractDetails } from "@Features/contracts/state/contracts.actions";
import { getBackendUrl } from "@Utils";
import { folderPermissions, presetSectionsCodeObject } from "@Helpers/constants";
import { EXPORT_TYPE, exportPdf } from "@Services/fileDownload";
import { RootState } from "@Reducers/index";
import type { RecentAccessResponse } from "@ServerTypes/recentAccess/recentAccess.schema";
import type { LocationControllerResponse, TeamsControllerResponse } from "@ServerTypes/projects/project.schema";
import type { TemplateQuestionField, TemplateSection } from "@Types/layout";
import { axiosWrapper } from "@AxiosWrapper";

type CustomFieldDataPayload = {
  eachField: TemplateQuestionField;
  answerValue: unknown;
  fieldIndex: number;
  sectionIndex: number;
  tableRowIndex?: number;
  source?: string;
  args?: unknown;
};
type HandleCustomFieldData = (payload: CustomFieldDataPayload) => void;

interface UseFormsProps {
  navigate?: any;
  params?: any;
  scheduleId?: any;
  contractId?: any;
  resourceId?: any;
  taskInspectionAndProgressFormsController?: any;
  userDetails?: any;
  portalData?: any;
  projectData?: any;
  getCurrencyData?: any;
  getContractDetailUrl?: any;
  getFormsListUrl?: any;
  uuid?: any;
  downloadFile?: any;
  mobile?: any;
  navigation?: any;
  bottomSheetRefFiles?: any;
  bottomSheetRefUsers?: any;
  bottomSheetRefAddedUsers?: any;
  projectId?: any;
}
const useForms = ({
  navigate,
  params,
  contractId,
  resourceId,
  taskInspectionAndProgressFormsController = async () => {},
  userDetails,
  portalData,
  projectData,
  getCurrencyData,
  getContractDetailUrl,
  getFormsListUrl,
  uuid,
  mobile = false,
  navigation,
  bottomSheetRefFiles,
  bottomSheetRefUsers,
  bottomSheetRefAddedUsers,
  projectId,
}: UseFormsProps) => {
  const { t } = useTranslation();
  const presetSectionsObject: any = getPresetSectionsObject();
  const dispatch = useDispatch();
  const abortControllerList = useRef<any>({});
  const { RESOURCE_MODIFY } = folderPermissions();
  const customModules = useSelector((state: RootState) => state.customModules);
  const [levelEditModal, setLevelEditModal] = useState<{
    open: boolean;
    levelIndex: number | null;
    editedLevel?: any;
    isValid?: boolean;
  }>({ open: false, levelIndex: null });
  const selectSignType = (args: any) => {
    const signType = args;
    if (!userDetails.signature && signType == SignTypeValues.IMPORT_PROFILE_SIGNATURE) {
      dispatch(
        showToastNotification({
          content: t("Profile sign not set") as TranslatedString,
          type: TOAST_TYPE_ERROR,
        }),
      );
    } else {
      setFormActionDetails((prev: any) => ({
        ...prev,
        signType,
        signDoc: null,
      }));
    }
  };

  const [inspectionData, setInspectionData] = useState<any>({});
  const [showAttachmentModal, setShowAttachmentModal] = useState(false);
  const [attachmentModalOpenedFor, setAttachmentModalOpenedFor] = useState<any>({});
  const [sideBarTaskDetails, setSideBarTaskDetails] = useState<any>([]);
  const [eachAnswerToSave, setEachAnswerToSave] = useState<any>({});
  const [answerSaved, setAnswerSaved] = useState(false);
  const [lastSaved, setLastSaved] = useState<any>(null);
  const [isFileUploading, setIsFileUploading] = useState<any>([]);
  // Tracks in-flight multi-file uploads per field so concurrent uploads to the same
  // field append to a shared, up-to-date answer array instead of each starting from the
  // answer value captured before its own (awaited) upload — which clobbers earlier files.
  // The entry only lives while uploads are in flight (refcounted), so once all settle the
  // next interaction reads the freshly committed answer again.
  const inFlightUploadsRef = useRef<Record<string, { count: number; value: any[] }>>({});
  const [openCommentDialog, setOpenCommentDialog] = useState<any>({
    status: false,
    source: "",
    heading: "",
    btnText: "",
  });
  const [formActionDetails, setFormActionDetails] = useState<any>({
    comment: "",
    signDoc: null,
    signType: SignTypeValues.ATTACH_SIGNED_DOCUMENT,
  });
  const [accordionExpandedState, setAccordionExpandedState] = useState<any>([]);
  const [showSideBar, setShowSideBar] = useState(true);
  const [showAddUsersModal, setShowAddUsersModal] = useState<any>({ status: false });
  const [showWarningModal, setShowWarningModal] = useState<any>({ status: false });
  const [modifySection, setModifySection] = useState<any>([]);
  const [actionBtnDisabled, setActionBtnDisabled] = useState(false);
  const [tableSectionConfig, setTableSectionConfig] = useState<any>({
    height: "max-h-60",
    expandMode: false,
  });
  const [showWaitSpinner, setShowWaitSpinner] = useState(false);
  const formValidator = useFormValidator({});

  // teams and location states for mobile
  const [teamData, setTeamData] = useState<any>(null);
  const [loactionData, setLoactionData] = useState<any>(null);
  const [isDataFetched, setIsDataFetched] = useState(false);
  const [imageFieldSelectedIndex, setImageFieldSelectedIndex] = useState<any>(null);
  const [openExportModal, setOpenExportModal] = useState<any>({
    state: false,
    paperSize: "A4",
    tableFormat: "card",
  });
  const [showUrlModal, setShowUrlModal] = useState<any>({ state: false });
  const [showGeoLocationModal, setShowGeoLocationModal] = useState<any>({ state: false });

  const formObject = useRef<any>(null);

  const commentSaveDisabledState =
    openCommentDialog?.source !== "rollBack" &&
    (formActionDetails.comment.trim() == "" ||
      (formActionDetails.signType === SignTypeValues.ATTACH_SIGNED_DOCUMENT && formActionDetails.signDoc == null));

  const ActionItems = inspectionData._id
    ? [
        ...(inspectionData.isSubmitted
          ? [
              {
                text: `${inspectionData.formFlow[inspectionData.currentLevelOfForm].approveBtnTxt}`,
                id: "approve",
                icon: "TickMark",
                disabled: (() => {
                  const allowedUserIdsToApprove = inspectionData.formFlow[
                    inspectionData.currentLevelOfForm
                  ].allowedUsersToApprove?.map((user: any) => user.id);
                  const approveBtnIsDisabled = !(
                    allowedUserIdsToApprove.includes(userDetails.id) && inspectionData.isSubmitted
                  );
                  return approveBtnIsDisabled;
                })(),
              },
            ]
          : [
              {
                text: `${inspectionData.formFlow[inspectionData.currentLevelOfForm].submitBtnTxt}`,
                id: "submit",
                icon: "TickMark",
                disabled: (() => {
                  const allowedUserIdsToSubmit =
                    inspectionData.formFlow[inspectionData.currentLevelOfForm].allowedUsersToSubmit?.map(
                      (user: any) => user.id,
                    ) || [];
                  const submitBtnIsDisabled =
                    !allowedUserIdsToSubmit.includes(userDetails.id) && !inspectionData.isArchived.status;
                  return submitBtnIsDisabled;
                })(),
              },
            ]),
        ...(Object.hasOwn(inspectionData.formFlow[inspectionData.currentLevelOfForm], "allowedUsersToRollBack")
          ? [
              {
                text: `${inspectionData.formFlow[inspectionData.currentLevelOfForm].rollBackBtnTxt}`,
                id: "rollBack",
                icon: "RollBackIcon",
                disabled: (() => {
                  const allowedUserIdsToRollBack =
                    inspectionData.formFlow[inspectionData.currentLevelOfForm].allowedUsersToRollBack?.map(
                      (user: any) => user.id,
                    ) || [];

                  const rollBackBtnIsDisabled = !allowedUserIdsToRollBack.includes(userDetails.id);
                  return rollBackBtnIsDisabled;
                })(),
              },
            ]
          : []),
        ...(Object.hasOwn(inspectionData.formFlow[inspectionData.currentLevelOfForm], "allowedUsersToReject")
          ? [
              {
                text: `${inspectionData.formFlow[inspectionData.currentLevelOfForm].rejectBtnTxt}`,
                id: "reject",
                icon: "Reject",
                disabled: (() => {
                  const allowedUserIdsToReject =
                    inspectionData.formFlow[inspectionData.currentLevelOfForm].allowedUsersToReject?.map(
                      (user: any) => user.id,
                    ) || [];

                  const rejectBtnIsDisabled = !allowedUserIdsToReject.includes(userDetails.id);
                  return rejectBtnIsDisabled;
                })(),
              },
            ]
          : []),
      ]
    : [];

  const sideBarAccordions = [
    ...(contractId
      ? [
          {
            type: "contractDetails",
            heading: t("Contract Details"),
            iconName: "details",
          },
        ]
      : []),
    { type: "details", heading: t("Details"), iconName: "details" },
    { type: "formFlow", heading: t("Form Flow"), iconName: "activity" },
    { type: "access", heading: t("Access"), iconName: "access" },
    { type: "issues", heading: t("Issues"), iconName: "IssuesIcon" },
  ];

  const fetchFormData = async () => {
    const res = await taskInspectionAndProgressFormsController({ resourceId });
    let data: any = {};
    if (_.get(res, "data.status", false)) {
      data = res.data.result[0];
      if (data) {
        let modifiedData = {
          ...data,
        };
        if (portalData?.frontendUrl?.includes("rustomjee") && data.resourceType == formCategories.bills) {
          const template = data.selectedForm.template?.map((section: any) => {
            const allQuestions = section.questionFields?.map((question: any) => {
              if (question.fieldLabel == "MBOOK_NO" && data.MBOOK_NO) {
                question.answer = {
                  value: data.MBOOK_NO,
                };
              }
              if (question.fieldLabel == "SES_NO" && data.SES_NO) {
                question.answer = {
                  value: data.SES_NO,
                };
              }
              return question;
            });
            section.questionFields = allQuestions;
            return section;
          });

          modifiedData = {
            ...data,
            selectedForm: {
              ...data.selectedForm,
              template,
            },
          };
        }
        setInspectionData(() => ({ ...modifiedData }));
      }
    }
    setIsDataFetched(true);
    return data;
  };
  const setInitialData = async () => {
    const data = await fetchFormData();
    if (data._id) {
      axiosWrapper!.post<RecentAccessResponse>(`${getBackendUrl()}/recentAccess/recentAccess`, {
        module: data.resourceType,
        metaData: {
          _id: resourceId,
          name: data.title,
          projectId: data.projectId,
          resourceType: data.resourceType,
        },
        projectId: data.projectId,
        platform: mobile ? PLATFORM.mobile : PLATFORM.web,
      });
      if (!mobile) {
        const allSectionsInCurrentLevel: Array<string> = [];
        data.formFlow[data.currentLevelOfForm].dataSource.map((data: any) => {
          data.sections.map((section: any) => allSectionsInCurrentLevel.push(section._id));
        });
        handleExpandSelectedSections(allSectionsInCurrentLevel);
      }
    }
    if (data.contractId) {
      dispatch(getContractDetails({ contractId: data.contractId }));
      dispatch(getCurrencyData({ projectId: params.projectId }));
    }
  };
  useEffect(() => {
    setInitialData();
  }, []);

  async function getLocationForMobile() {
    const teamRawResponse = await axiosWrapper!.post<LocationControllerResponse>(
      `${getBackendUrl()}/projects/locationController`,
      {
        value: { params: { projectId }, projectId },
      },
    );
    let teamResponse: any = teamRawResponse.data.result;
    return teamResponse;
  }

  async function getTeamDataForMobile() {
    const locationRawResponse = await axiosWrapper!.post<TeamsControllerResponse>(
      `${getBackendUrl()}/projects/teamsController`,
      {
        value: { params: { projectId }, projectId },
      },
    );
    let locationResponse: any = locationRawResponse.data.result;
    return locationResponse;
  }

  const handleChangeAnswer = ({
    source,
    answerValue,
    fieldIndex,
    sectionIndex,
    tableRowIndex,
    questionId,
  }: {
    source: any;
    answerValue: any;
    fieldIndex: any;
    sectionIndex: any;
    tableRowIndex: any;
    questionId: any;
  }) => {
    // Mark the form-data update as a non-urgent transition so the browser can paint
    // the typed character before React re-renders the entire form tree. Without this,
    // every keystroke synchronously re-renders all sections/fields and delays paint.
    startTransition(() => {
      if (source == formSectionType.FORM) {
        setInspectionData((prev: { selectedForm: { template: TemplateSection[] }; [key: string]: unknown }) => {
          const modifiedTemplate = [...prev.selectedForm.template];
          const questionField = modifiedTemplate[sectionIndex]?.questionFields[fieldIndex];
          if (questionField) {
            questionField.answer = questionField.answer
              ? { ...questionField.answer, value: answerValue }
              : { value: answerValue };
          }
          return {
            ...prev,
            selectedForm: {
              ...prev.selectedForm,
              template: modifiedTemplate,
            },
          };
        });
      } else {
        setInspectionData((prev: { selectedForm: { template: TemplateSection[] }; [key: string]: unknown }) => {
          const modifiedTemplate = [...prev.selectedForm.template];
          const section = modifiedTemplate[sectionIndex];
          if (section) {
            section.tableDataSource = section.tableDataSource.map((row: Record<string, unknown>, index: number) => {
              if (index == tableRowIndex) {
                row[questionId] = {
                  createdDate: Date.now(),
                  createdBy: userDetails._id,
                  value: answerValue,
                };
              }
              return row;
            });
          }
          return {
            ...prev,
            selectedForm: {
              ...prev.selectedForm,
              template: modifiedTemplate,
            },
          };
        });
      }
    });
  };

  function getMultiSelectValue(args: any, currentAnswer: any, viewType: any) {
    if (viewType === optionsViewType.LIST) {
      const prevAns = currentAnswer?.value || [];
      return args.checked ? [...prevAns, args.value] : prevAns.filter((ans: any) => ans !== args.value);
    }

    if (viewType === optionsViewType.DROPDOWN) {
      return args || [];
    }

    return [];
  }

  const handleMobile = ({
    args,
    answerValue,
    sectionIndex,
    eachField,
    section,
    source,
    tableRowIndex,
    fieldIndex,
  }: {
    args: any;
    source: any;
    answerValue: any;
    fieldIndex: any;
    sectionIndex: any;
    tableRowIndex: any;
    eachField: any;
    section: any;
  }) => {
    const { _id, fieldType, viewType = optionsViewType.LIST } = eachField;
    let currentAnswer = eachField.answer ?? {};

    if (source === formSectionType.TABLE_SECTION) {
      currentAnswer = section.tableDataSource[tableRowIndex]?.[_id] ?? {};
    }

    switch (fieldType) {
      case "single-line":
      case "multi-line":
      case "single-select":
        answerValue = args;
        break;

      case "multi-select":
        answerValue = getMultiSelectValue(args, currentAnswer, viewType);
        break;

      case "date-time":
        answerValue = args.getTime();
        break;

      case "look-up":
        answerValue = args;
        break;

      case "number":
        answerValue = Number(args.replace(/\D/g, ""));
        break;

      case "geoLocation":
        answerValue = args;
        break;

      default:
        break;
    }

    handleChangeAnswer({
      source,
      answerValue,
      fieldIndex,
      sectionIndex,
      tableRowIndex,
      questionId: _id,
    });

    return answerValue;
  };

  const handleInputChange = async ({
    args,
    answerValue,
    sectionIndex,
    eachField,
    section,
    source = "",
    tableRowIndex,
    fieldIndex,
  }: {
    args: any;
    answerValue: any;
    sectionIndex: any;
    eachField: any;
    section: any;
    source: any;
    tableRowIndex: any;
    fieldIndex: any;
  }) => {
    const { _id } = eachField;

    const questionId: any = _id;
    const sectionId: any = section._id;
    if (mobile) {
      answerValue = handleMobile({
        args,
        answerValue,
        sectionIndex,
        eachField,
        section,
        source,
        tableRowIndex,
        fieldIndex,
      });
    }
    if (![undefined, NaN].includes(answerValue)) {
      if (source == formSectionType.FORM) {
        setEachAnswerToSave({
          sectionId,
          questionId,
          answer: { value: answerValue },
        });
      } else {
        const modifiedTemplate = _.cloneDeep(inspectionData.selectedForm.template);
        const modifiedTableDataSource = modifiedTemplate[sectionIndex].tableDataSource.map(
          (row: any, index: number) => {
            if (index == tableRowIndex) {
              row[_id] = {
                createdDate: Date.now(),
                createdBy: userDetails._id,
                value: answerValue,
              };
            }
            return row;
          },
        );
        setEachAnswerToSave({
          tableSectionId: sectionId,
          tableSectionDataSource: modifiedTableDataSource,
        });
      }
    }
  };

  const fileToBase64 = async (file: File) =>
    new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (e) => {
        console.log(e);
      };
    });

  const validateMaxFiles = (eachField: any, prevAns: any) => {
    if (eachField.maxNoOfFiles && prevAns && prevAns.length >= eachField.maxNoOfFiles) {
      dispatch(
        showToastNotification({
          content: t("Max only {{count}} files can be uploaded", { count: eachField.maxNoOfFiles }) as TranslatedString,
          type: TOAST_TYPE_ERROR,
        }),
      );
      return false;
    }
    return true;
  };

  const validateFileType = (file: any, eachField: any, allowedFileTypes: any) => {
    if (
      (eachField.fieldType === "image" && !allowedFileTypes.includes(file.type)) ||
      (eachField.fieldType === "fileUpload" && allowedFileTypes.length && !allowedFileTypes.includes(file.type))
    ) {
      dispatch(
        showToastNotification({
          content: t("File type not allowed") as TranslatedString,
          type: TOAST_TYPE_ERROR,
        }),
      );
      return false;
    }
    return true;
  };

  const validateFileSize = (file: any, e: any) => {
    const maxFileSizeInBytes = 10 * 1024 * 1024;
    if (file.size > maxFileSizeInBytes) {
      const msg = t("File size exceeds the limit. Max file size allowed is {{max, number}} MB", { max: 10 });
      if (mobile) {
        dispatch(showToastNotification({ content: msg as TranslatedString, type: TOAST_TYPE_WARNING }));
      } else {
        alert(msg);
        e.target.value = "";
      }
      return false;
    }
    return true;
  };

  const updateFormTemplate = (args: any, fileMeta: any, fileBase64Str: any) => {
    const { formData, sectionIndex, fieldIndex, sectionId, eachField, tableRowIndex, source } = args;
    const questionId = eachField._id;
    const modifiedTemplate = _.cloneDeep(formData.selectedForm.template);
    let answerValue = [{ ...fileMeta }];

    if (source === formSectionType.FORM) {
      if (eachField.answer?.value) {
        answerValue = [...eachField.answer.value, fileMeta];
      }
      modifiedTemplate[sectionIndex].questionFields[fieldIndex].answer = { value: answerValue };

      return {
        template: modifiedTemplate,
        data: {
          addFileUploadFieldData: { fileBase64Str, awsKey: fileMeta.awsKey },
          answer: { value: answerValue },
          sectionId,
          questionId,
        },
      };
    }

    const prevAns = formData.selectedForm.template[sectionIndex].tableDataSource[tableRowIndex][questionId]?.value;
    if (prevAns) answerValue = [...prevAns, fileMeta];

    modifiedTemplate[sectionIndex].tableDataSource = modifiedTemplate[sectionIndex].tableDataSource.map(
      (row: any, i: number) =>
        i === tableRowIndex
          ? {
              ...row,
              [questionId]: { createdBy: userDetails._id, createdDate: Date.now(), value: answerValue },
            }
          : row,
    );

    return {
      template: modifiedTemplate,
      data: {
        tableSectionId: sectionId,
        tableSectionDataSource: [...modifiedTemplate[sectionIndex].tableDataSource],
        addFileUploadFieldData: { fileBase64Str, awsKey: fileMeta.awsKey },
      },
    };
  };

  const base64ToFile = (base64EncodedImg: string) => {
    const [meta = "", base64Data = ""] = base64EncodedImg.split(",");
    const mimeType = meta.match(/data:(.*?);base64/)?.[1] || "image/jpeg";
    const byteString = atob(base64Data);
    const byteArray = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i += 1) {
      byteArray[i] = byteString.charCodeAt(i);
    }
    const extension = mimeType.split("/")[1] || "jpeg";
    return new File([byteArray], `${uuid()}.${extension}`, { type: mimeType });
  };

  const handleFileUploadInTemplate = async (file: File | string) => {
    const fileToUpload = typeof file === "string" && file.startsWith("data:") ? base64ToFile(file) : (file as File);

    const formDataForFile = new FormData();
    formDataForFile.append("uploadFiles", fileToUpload);
    const response = await axiosWrapper.post<{ status: boolean; uuid?: string; errorMessage?: string }>(
      `${getBackendUrl()}/forms/uploadFilesInTemplate`,
      formDataForFile,
      { headers: { "Content-Type": "multipart/form-data" } },
    );

    if (!response?.data?.status || !response.data.uuid) return;
    return response.data.uuid;
  };
  const handleFileUploadChange = async (args: any) => {
    const {
      e,
      eachField,
      sectionIndex,
      tableRowIndex,
      source,
      tableRowId = null,
      formData = {},
      handleCustomFieldData,
      fieldIndex,
    } = args;

    const questionId = eachField._id;
    const allowedFileTypes = eachField.allowedFileTypes || [];
    let prevAns = eachField.answer?.value || [];

    if (source === formSectionType.TABLE_SECTION) {
      prevAns = formData.selectedForm.template[sectionIndex].tableDataSource[tableRowIndex]?.[questionId]?.value || [];
    }

    if (!validateMaxFiles(eachField, prevAns)) return;
    const file: any = mobile ? e : e.target.files?.[0];
    if (!file) return;
    if (!validateFileType(file, eachField, allowedFileTypes)) return;
    if (!validateFileSize(file, e)) return;

    let fileBase64Str = file.base64;
    if (!mobile) {
      if (!(file instanceof File)) {
        dispatch(
          showToastNotification({
            content: t("Invalid file") as TranslatedString,
            type: TOAST_TYPE_WARNING,
          }),
        );
        return;
      }
      fileBase64Str = await fileToBase64(file);
    }
    const awsKey = uuid();
    const fileMeta = { type: file.type, name: file.name || file.fileName, awsKey };

    const { template, data } = updateFormTemplate(args, fileMeta, fileBase64Str);

    const uniqueId = tableRowId ? `${tableRowId}${questionId}` : questionId;

    setIsFileUploading((prev: any) => [...prev, { type: eachField.fieldType, uniqueId }]);

    // Seed/refcount the shared in-flight accumulator for this field so that a second
    // upload that starts before this one resolves appends to the same array.
    const existingInFlight = inFlightUploadsRef.current[uniqueId];
    if (existingInFlight) {
      existingInFlight.count += 1;
    } else {
      inFlightUploadsRef.current[uniqueId] = { count: 1, value: prevAns };
    }

    try {
      if (handleCustomFieldData) {
        const UUID = await handleFileUploadInTemplate(file);
        if (UUID) {
          // Append to the current (possibly already-grown) value at apply time, not to the
          // stale prevAns captured before the upload, so concurrent uploads don't clobber.
          const current = inFlightUploadsRef.current[uniqueId];
          const base = current ? current.value : prevAns;
          const answerValue = [...base, { ...fileMeta, awsKey: UUID }];
          if (current) current.value = answerValue;
          handleCustomFieldData({
            eachField,
            fieldIndex,
            answerValue,
            sectionIndex,
            tableRowIndex,
            source,
          });
        }
      } else if (inspectionData._id) {
        const res = await taskInspectionAndProgressFormsController({ action: "update", _id: resourceId, data });
        if (res.data.status) {
          setAnswerSaved(true);
          if (!mobile) setTimeout(() => setAnswerSaved(false), 500);
          dispatch(
            showToastNotification({ content: t("File uploaded") as TranslatedString, type: TOAST_TYPE_SUCCESS }),
          );
          setInspectionData((prev: any) => ({
            ...prev,
            lastSaved: res.data.lastSaved,
            selectedForm: { ...prev.selectedForm, template },
          }));
        } else {
          dispatch(showToastNotification({ content: untranslated(res.data.errorMessage), type: TOAST_TYPE_ERROR }));
        }
      }
    } finally {
      // Always clear the per-field spinner, even if the upload/save throws (5xx/network),
      // and release the in-flight accumulator once the last concurrent upload settles.
      const current = inFlightUploadsRef.current[uniqueId];
      if (current) {
        current.count -= 1;
        if (current.count <= 0) delete inFlightUploadsRef.current[uniqueId];
      }
      setIsFileUploading((prev: any) => prev.filter((d: any) => d.uniqueId !== uniqueId));
    }
  };

  const saveEditedImage = async ({
    base64EncodedImg,
    awsKey,
    handleCustomFieldData,
    sectionId,
    questionId,
    eachField,
    fieldIndex,
    sectionIndex,
    tableRowIndex,
    source,
    imageIndex,
    currentAnswer,
  }: {
    eachField: TemplateQuestionField;
    fieldIndex: number;
    sectionIndex: number;
    tableRowIndex: number;
    source: string;
    base64EncodedImg: any;
    imageIndex: number;
    awsKey: any;
    handleCustomFieldData: any;
    sectionId: string;
    questionId: string;
    // Source-resolved answer (per-row for table sections); see useQuestionFields.
    currentAnswer?: { value?: any[] };
  }) => {
    if (handleCustomFieldData) {
      const UUID = await handleFileUploadInTemplate(base64EncodedImg);
      if (UUID) {
        // In a table section the answer lives per-row, not on eachField.answer — use the
        // already-resolved currentAnswer. Build a new array instead of mutating in place.
        const updateAns = (currentAnswer?.value ?? []).map((image: any, index: number) =>
          index === imageIndex ? { ...image, awsKey: UUID } : image,
        );
        handleCustomFieldData({
          eachField,
          fieldIndex,
          answerValue: updateAns,
          sectionIndex,
          tableRowIndex,
          source,
        });
      }
    } else if (inspectionData._id) {
      setEachAnswerToSave({
        addFileUploadFieldData: { fileBase64Str: base64EncodedImg, awsKey },
        sectionId,
        questionId,
      });
    }
  };

  const handleRemoveUploadedFile = ({
    fileData,
    sectionIndex,
    fieldIndex,
    sectionId,
    questionId,
    source,
    tableRowIndex,
    eachField,
    handleCustomFieldData,
    currentAnswer,
  }: {
    eachField: TemplateQuestionField;
    fileData: any;
    sectionIndex: any;
    fieldIndex: any;
    sectionId: any;
    questionId: any;
    source: any;
    tableRowIndex: any;
    handleCustomFieldData: any;
    currentAnswer?: { value?: any[] };
  }) => {
    const { awsKey, fileVersion } = fileData;
    const matchingValue = awsKey || fileVersion;
    const matchingKey = awsKey ? "awsKey" : "fileVersion";

    if (handleCustomFieldData) {
      const modifiedAnswer = (currentAnswer?.value ?? []).filter((data: any) => data[matchingKey] != matchingValue);
      handleCustomFieldData({
        eachField,
        fieldIndex,
        answerValue: modifiedAnswer,
        sectionIndex,
        tableRowIndex,
        source,
      });
    } else if (inspectionData._id) {
      const modifiedTemplate = [...inspectionData.selectedForm.template];
      if (source == formSectionType.FORM) {
        const fileIndex = eachField.answer?.value.findIndex((file) => file.awsKey === awsKey);
        const modifiedAnswer = eachField.answer?.value.filter((data: any) => data[matchingKey] != matchingValue);

        modifiedTemplate[sectionIndex].questionFields[fieldIndex].answer = {
          ...modifiedTemplate[sectionIndex].questionFields[fieldIndex].answer,
          value: modifiedAnswer,
        };

        setInspectionData((prev: any) => ({
          ...prev,
          selectedForm: {
            ...prev.selectedForm,
            template: modifiedTemplate,
          },
        }));

        const payload: any = {
          answer: { value: modifiedAnswer },
          sectionId,
          questionId,
        };
        if (awsKey) {
          payload.removeFileUploadFieldData = { fileIndex };
        }
        setEachAnswerToSave(payload);
      } else {
        const fileIndex = modifiedTemplate[sectionIndex].tableDataSource[tableRowIndex][questionId].value.findIndex(
          (file) => file.awsKey === awsKey,
        );
        const modifiedAnswer = modifiedTemplate[sectionIndex].tableDataSource[tableRowIndex][questionId]?.value.filter(
          (data: any) => data[matchingKey] != matchingValue,
        );

        modifiedTemplate[sectionIndex].tableDataSource = modifiedTemplate[sectionIndex].tableDataSource.map(
          (row: any, index: number) => {
            if (index == tableRowIndex) {
              row[questionId] = {
                createdBy: userDetails._id,
                createdDate: Date.now(),
                value: modifiedAnswer,
              };
            }
            return row;
          },
        );

        setInspectionData((prev: any) => ({
          ...prev,
          selectedForm: {
            ...prev.selectedForm,
            template: modifiedTemplate,
          },
        }));

        const payload: any = {
          tableSectionId: sectionId,
          questionId,
          tableSectionDataSource: [...modifiedTemplate[sectionIndex].tableDataSource],
        };
        if (awsKey) {
          payload.removeFileUploadFieldData = { tableRowIndex, fileIndex };
        }
        setEachAnswerToSave(payload);
      }
    }
  };

  const manageAbortControllers = (questionId: any, abortController: any) => {
    if (!questionId) return;

    const existingControllers: any = _.get(abortControllerList, `current.${questionId}`);
    if (existingControllers) {
      existingControllers.forEach((c: any) => c.abort());
      abortControllerList.current[questionId] = [];
    }

    if (abortControllerList.current[questionId]) {
      abortControllerList.current[questionId].push(abortController);
    } else {
      abortControllerList.current[questionId] = [abortController];
    }
  };
  const updateAttachments = (res: any, eachAnswerToSave: any, setInspectionData: any) => {
    if (!res.data.addedAttachmentData && !res.data.autoFieldAnswers) return;

    setInspectionData((prev: any) => {
      const { addedAttachmentData, autoFieldAnswers, lastSaved } = res.data;

      const { sectionIndex, fieldIndex } = eachAnswerToSave;
      const attachmentObj = addedAttachmentData?.obj;

      const newTemplate = prev.selectedForm.template.map((section: TemplateSection, sIdx: number) => {
        if (!section.questionFields) return section;

        let sectionChanged = false;

        const newQuestionFields = section.questionFields.map((field: TemplateQuestionField, fIdx: number) => {
          let updated = field;

          // 1. Attachment addition — only the targeted field.
          if (attachmentObj && sIdx === sectionIndex && fIdx === fieldIndex) {
            updated = {
              ...updated,
              attachmentsData: [...(updated.attachmentsData ?? []), { ...attachmentObj }],
            };
          }

          // 2. Auto-field answer — any field whose _id is in the map.
          if (
            autoFieldAnswers &&
            updated._id != null &&
            Object.prototype.hasOwnProperty.call(autoFieldAnswers, updated._id)
          ) {
            updated = {
              ...updated,
              answer: { ...updated.answer, value: autoFieldAnswers[updated._id] },
            };
          }

          if (updated !== field) sectionChanged = true;
          return updated;
        });

        return sectionChanged ? { ...section, questionFields: newQuestionFields } : section;
      });

      return {
        ...prev,
        lastSaved,
        answerMap: autoFieldAnswers ? { ...prev.answerMap, ...autoFieldAnswers } : prev.answerMap,
        selectedForm: { ...prev.selectedForm, template: newTemplate },
      };
    });
  };
  const setEachAnswer = async () => {
    if (!Object.keys(eachAnswerToSave).length) return;

    const abortController = new AbortController();
    const questionId = _.get(eachAnswerToSave, "questionId") || _.get(eachAnswerToSave, "tableSectionId");

    manageAbortControllers(questionId, abortController);

    try {
      const res = await taskInspectionAndProgressFormsController(
        { action: "update", _id: resourceId, data: eachAnswerToSave },
        abortController,
      );

      updateAttachments(res, eachAnswerToSave, setInspectionData);

      if (res.data.status) {
        setAnswerSaved(true);
        setTimeout(() => setAnswerSaved(false), 500);
        setLastSaved(res.data.lastSaved);
      } else {
        dispatch(
          showToastNotification({
            content: res.data.errorMessage,
            type: TOAST_TYPE_ERROR,
          }),
        );
      }
    } catch (error) {
      console.error(error);
      Promise.reject(error);
    }
  };

  useEffect(() => {
    setEachAnswer();
  }, [eachAnswerToSave]);

  useEffect(() => {
    if (inspectionData?._id && isDataFetched) {
      addValidationToForms({
        formValidator,
        inspectionData,
        modifySection,
      });
    }
  }, [inspectionData?._id, inspectionData?.currentLevelOfForm, modifySection, isDataFetched]);

  const openAddUserModal = ({
    eachField,
    fieldIndex,
    sectionIndex,
    section,
    source = formSectionType.FORM,
    tableRowIndex,
    handleCustomFieldData,
    tableRowId,
  }: {
    eachField: any;
    fieldIndex: number;
    sectionIndex: number;
    section: any;
    source: string;
    tableRowIndex: number;
    handleCustomFieldData: any;
    tableRowId: string;
  }) => {
    if (eachField.onlyCurrentUser) {
      const currentUser = {
        _id: userDetails.id,
        signature: userDetails.signature,
        firstName: userDetails.firstName,
        fullName: userDetails.fullName,
        lastName: userDetails.lastName,
      };
      if (handleCustomFieldData) {
        handleCustomFieldData({
          eachField,
          answerValue: currentUser,
          fieldIndex,
          sectionIndex,
          tableRowIndex,
          source,
        });
      } else if (inspectionData._id) {
        const modifiedTemplate = [...inspectionData.selectedForm.template];
        if (source == formSectionType.FORM) {
          modifiedTemplate[sectionIndex].questionFields[fieldIndex].answer = {
            value: [currentUser],
          };
          setInspectionData((prev: any) => ({
            ...prev,
            selectedForm: {
              ...prev.selectedForm,
              template: modifiedTemplate,
            },
          }));

          setEachAnswerToSave({
            sectionId: section._id,
            questionId: eachField._id,
            answer: { value: [currentUser] },
          });
        } else {
          modifiedTemplate[sectionIndex].tableDataSource[tableRowIndex][eachField._id] = {
            createdBy: userDetails._id,
            createdDate: Date.now(),
            value: [currentUser],
          };
          setInspectionData((prev: any) => ({
            ...prev,
            selectedForm: {
              ...prev.selectedForm,
              template: modifiedTemplate,
            },
          }));

          setEachAnswerToSave({
            tableSectionId: section._id,
            tableSectionDataSource: [...modifiedTemplate[sectionIndex].tableDataSource],
          });
        }
        if (mobile) {
          dispatch(
            showToastNotification({
              content: t("User Added") as TranslatedString,
              type: TOAST_TYPE_SUCCESS,
            }),
          );
        }
      }
      return;
    }
    setShowAddUsersModal({
      status: true,
      fieldData: { ...eachField },
      fieldIndex,
      sectionIndex,
      section,
      source,
      tableRowIndex,
      uniqueId: tableRowId ? `${tableRowId}${eachField._id}` : eachField._id,
    });
    bottomSheetRefUsers?.current?.present();
  };

  const closeUsersModal = () => {
    setShowAddUsersModal({ status: false });
  };

  const removeUserFromList = ({
    fieldIndex,
    sectionIndex,
    user,
    eachField,
    section,
    source = formSectionType.FORM,
    tableRowIndex,
    handleCustomFieldData,
  }: {
    fieldIndex: any;
    sectionIndex: any;
    user: any;
    eachField: any;
    section: any;
    source: any;
    tableRowIndex: any;
    handleCustomFieldData: any;
  }) => {
    if (handleCustomFieldData) {
      const allUsers = eachField.answer.value;
      const filteredUsers = allUsers.filter((data: any) => data._id != user._id);
      handleCustomFieldData({
        eachField,
        answerValue: filteredUsers,
        fieldIndex,
        sectionIndex,
        tableRowIndex,
        source,
      });
    } else if (inspectionData._id) {
      const modifiedTemplate = [...inspectionData.selectedForm.template];
      if (source == formSectionType.FORM) {
        const allUsers = modifiedTemplate[sectionIndex].questionFields[fieldIndex].answer.value;
        const filteredUsers = allUsers.filter((data: any) => data._id != user._id);

        modifiedTemplate[sectionIndex].questionFields[fieldIndex].answer = {
          value: filteredUsers,
        };

        setInspectionData((prev: any) => ({
          ...prev,
          selectedForm: {
            ...prev.selectedForm,
            template: modifiedTemplate,
          },
        }));

        setEachAnswerToSave({
          sectionId: section._id,
          questionId: eachField._id,
          answer: { value: filteredUsers },
        });

        mobile &&
          setShowAddUsersModal({
            ...showAddUsersModal,
            status: true,
            fieldData: modifiedTemplate[sectionIndex].questionFields[fieldIndex],
            fieldIndex,
            sectionIndex,
            section,
            source,
            tableRowIndex,
          });
      } else {
        const allUsers = modifiedTemplate[sectionIndex].tableDataSource[tableRowIndex][eachField._id].value;
        const filteredUsers = allUsers.filter((data: any) => data._id != user._id);

        modifiedTemplate[sectionIndex].tableDataSource[tableRowIndex][eachField._id] = {
          createdBy: userDetails._id,
          createdDate: Date.now(),
          value: filteredUsers,
        };

        setInspectionData((prev: any) => ({
          ...prev,
          selectedForm: {
            ...prev.selectedForm,
            template: modifiedTemplate,
          },
        }));

        setEachAnswerToSave({
          tableSectionId: section._id,
          tableSectionDataSource: [...modifiedTemplate[sectionIndex].tableDataSource],
        });
        mobile &&
          setShowAddUsersModal({
            ...showAddUsersModal,
            status: true,
            fieldData: modifiedTemplate[sectionIndex].questionFields[fieldIndex],
            fieldIndex,
            sectionIndex,
            section,
            source,
            tableRowIndex,
          });
      }
    }
  };

  const openAddedUserModalInMobile = ({
    eachField,
    fieldIndex,
    sectionIndex,
    showCrossIcon = false,
    section,
    source,
    tableRowIndex,
  }: {
    eachField: any;
    fieldIndex: any;
    sectionIndex: any;
    showCrossIcon: any;
    section: any;
    source: any;
    tableRowIndex: any;
  }) => {
    setShowAddUsersModal({
      status: true,
      fieldData: { ...eachField },
      fieldIndex,
      sectionIndex,
      showCrossIcon,
      section,
      source,
      tableRowIndex,
    });
    bottomSheetRefAddedUsers?.current?.present();
  };

  const verifySection = (sectionIds: any) => {
    let uniqueSectionIds: any = new Set([...sectionIds, ...inspectionData.sectionsVerified]);
    uniqueSectionIds = Array.from(uniqueSectionIds);
    setInspectionData((prev: any) => ({
      ...prev,
      sectionsVerified: uniqueSectionIds,
    }));
    setEachAnswerToSave({ sectionsVerified: [...uniqueSectionIds] });
  };

  function handleAttachmentClick(sectionIndex: any, fieldIndex: any) {
    setShowAttachmentModal(true);
    setAttachmentModalOpenedFor({
      sectionIndex,
      fieldIndex,
    });
    bottomSheetRefFiles?.current?.present();
  }

  const closeAttachmentModal = () => {
    setShowAttachmentModal(false);
  };

  const handleModifyCancel = (event: any, sectionId: any) => {
    event?.stopPropagation();
    setModifySection((prev: any) => prev.filter((id: any) => id != sectionId));
  };

  const verifyToggleStatus = (section: any) => {
    const allowedUsersToVerifyPostSub = section.permissions[inspectionData.currentLevelOfForm].Verify;
    return !(allowedUsersToVerifyPostSub.includes(userDetails.id) && inspectionData.isSubmitted);
  };

  const saveInspectionData = async (type: any) => {
    const data: any = {};
    if (type == "submit") {
      const { editedLevel, levelIndex } = levelEditModal;
      if (editedLevel && levelIndex !== null) {
        data.editedLevel = editedLevel;
      }
      if (inspectionData.currentLevelOfForm == inspectionData.formFlow.length - 2) {
        data.isSubmitted = true;
      } else {
        data.isSubmitted = false;
        data.proceedToNextLevel = true;
      }
    } else if (type == "approve") {
      data.isApproved = true;
    } else if (type == "reject") {
      data.isRejected = true;
    } else if (type == "rollback") {
      data.rollBack = true;
    }
    if (["approve", "reject", "rollback"].includes(type)) {
      data.actionComment = formActionDetails.comment;
      data.actionSignDoc = formActionDetails.signDoc;
      data.actionSignType = formActionDetails.signType;
    }
    setActionBtnDisabled(true);
    const res = await taskInspectionAndProgressFormsController({
      action: "update",
      _id: resourceId,
      data,
    });
    setActionBtnDisabled(false);
    return res;
  };

  const handleRollBack = async () => {
    setShowWaitSpinner(true);
    setActionBtnDisabled(true);
    const res = await saveInspectionData("rollback");
    if (res.data.status) {
      dispatch(
        showToastNotification({
          content: t("Form Rolled back to previous level"),
          type: TOAST_TYPE_SUCCESS,
        }),
      );
      const updatedFormFLow = [...inspectionData.formFlow];
      updatedFormFLow[inspectionData.currentLevelOfForm - 1].actionStatus = false;
      updatedFormFLow[inspectionData.currentLevelOfForm - 1].actionDetails = {};
      await fetchFormData();
      closeCommentDialog();
    } else {
      dispatch(
        showToastNotification({
          content: res.data.errorMessage,
          type: TOAST_TYPE_ERROR,
        }),
      );
      setShowWaitSpinner(false);
    }
    setActionBtnDisabled(false);
  };

  const handleFormActionClick = (args: any) => {
    if (args.item.id == "approve") {
      if (inspectionData.sectionsVerified?.length != inspectionData.selectedForm.template.length) {
        dispatch(
          showToastNotification({
            content: t("Please verify all sections before approving the form") as TranslatedString,
            type: TOAST_TYPE_ERROR,
          }),
        );
      } else {
        setOpenCommentDialog({ status: true, heading: "Approve", btnText: "Approve", source: "approve" });
      }
    }
    if (args.item.id == "reject") {
      setOpenCommentDialog({ status: true, heading: "Reject", btnText: "Reject", source: "reject" });
    }
    if (args.item.id == "submit") {
      handleSubmitClick();
    }
    if (args.item.id == "rollBack") {
      setOpenCommentDialog({ status: true, heading: "Roll Back", btnText: "Roll Back", source: "rollBack" });
    }
  };

  const beforeOpenActionDropdown = (args: any) => {
    const items = args?.items;
    if (!items?.length) return;

    const currentFlow = inspectionData.formFlow?.[inspectionData.currentLevelOfForm];
    if (!currentFlow) return;

    const findItem = (id: string) => items.find((it: { id?: string; disabled?: boolean }) => it?.id === id);
    const allowedIds = (key: string) => (currentFlow[key]?.map((user: { id: string }) => user.id) ?? []) as string[];

    const rollBackItem = findItem("rollBack");
    if (rollBackItem && Object.hasOwn(currentFlow, "allowedUsersToRollBack")) {
      rollBackItem.disabled = !allowedIds("allowedUsersToRollBack").includes(userDetails.id);
    }

    const rejectItem = findItem("reject");
    if (rejectItem && Object.hasOwn(currentFlow, "allowedUsersToReject")) {
      rejectItem.disabled = !allowedIds("allowedUsersToReject").includes(userDetails.id);
    }

    if (inspectionData.isSubmitted) {
      const approveItem = findItem("approve");
      if (approveItem) {
        approveItem.disabled = !(
          allowedIds("allowedUsersToApprove").includes(userDetails.id) && inspectionData.isSubmitted
        );
      }
    } else {
      const submitItem = findItem("submit");
      if (submitItem) {
        submitItem.disabled =
          !allowedIds("allowedUsersToSubmit").includes(userDetails.id) && !inspectionData.isArchived?.status;
      }
    }
  };

  const handleFormStateChange = async () => {
    const res = await taskInspectionAndProgressFormsController({
      action: "archive",
      resourceIds: [inspectionData._id],
      data: { isArchived: { status: true } },
    });

    if (res.data.status) {
      dispatch(
        showToastNotification({
          content: t("Successfully Archived") as TranslatedString,
          type: TOAST_TYPE_SUCCESS,
        }),
      );
    }
    let urlLink;
    if (inspectionData?.contractId) {
      urlLink = getContractDetailUrl({
        selectedTab: formCategoryObject[inspectionData.resourceType]?.selectedTab ?? "list",
        projectId: params.projectId,
        contractId: inspectionData?.contractId,
      });
    } else {
      urlLink = getFormsListUrl({
        selectedTab: "list",
        projectId: params.projectId,
        resourceType: inspectionData.resourceType,
      });
    }
    navigate(urlLink);
  };

  const handleCollapseAll = () => {
    setAccordionExpandedState([]);
  };
  const handleExpandAll = (template = []) => {
    const sectionIds: Array<string> = template?.map((section: any) => section._id);
    setAccordionExpandedState([...sectionIds]);
  };

  const handleExpandSelectedSections = (sectionIds: Array<string>) => {
    setAccordionExpandedState((prev: Array<string>) => [...prev, ...sectionIds]);
  };

  const handleAccStateChange = (args: any, sectionId: any) => {
    setAccordionExpandedState((prev: any) => {
      if (prev.includes(sectionId)) {
        return prev.filter((id: any) => id != sectionId);
      }

      return [...prev, sectionId];
    });
  };

  const showToastAndRedirect = (content: any) => {
    dispatch(
      showToastNotification({
        content,
        type: TOAST_TYPE_SUCCESS,
      }),
    );
    if (inspectionData?.contractId) {
      if (!mobile) {
        const urlLink = getContractDetailUrl({
          selectedTab: formCategoryObject[inspectionData.resourceType]?.selectedTab ?? "list",
          projectId: params.projectId,
          contractId: inspectionData?.contractId,
        });
        navigate(urlLink);
      } else {
        navigation.replace("FormsList", {
          formList: inspectionData.resourceType,
          projectId: params.projectId,
          contractId: inspectionData?.contractId,
        });
      }
    } else if (!mobile) {
      const urlLink = getFormsListUrl({
        selectedTab: "list",
        projectId: params.projectId,
        resourceType: inspectionData.resourceType,
      });
      navigate(urlLink);
    } else {
      navigation.replace("FormsList", {
        formList: inspectionData.resourceType,
        projectId: params.projectId,
      });
    }
  };

  const handleFormSubmission = async () => {
    const { isAllMandatoryFieldsFilled, errorToastContent } = checkMandatoryFields(inspectionData);
    if (isAllMandatoryFieldsFilled) {
      const res = await saveInspectionData("submit");
      if (res.data.status) {
        await fetchFormData();
        dispatch(
          showToastNotification({
            content: t("Form submitted successfully navigate back to see full list") as TranslatedString,
            type: TOAST_TYPE_SUCCESS,
          }),
        );
      } else {
        dispatch(
          showToastNotification({
            content: res.data.errorMessage,
            type: TOAST_TYPE_ERROR,
          }),
        );
      }
    } else {
      dispatch(
        showToastNotification({
          content: untranslated(errorToastContent),
          type: TOAST_TYPE_ERROR,
        }),
      );
      formValidator.validateAll();
    }
  };
  const handleSubmitClick = async () => {
    if (
      !mobile &&
      inspectionData.currentLevelOfForm < inspectionData.formFlow.length - 1 &&
      inspectionData.formFlow[inspectionData.currentLevelOfForm + 1].allowDynamicUserConfig
    ) {
      setLevelEditModal(() => ({
        open: true,
        levelIndex: inspectionData.currentLevelOfForm + 1,
      }));
    } else {
      await handleFormSubmission();
    }
  };

  const closeCommentDialog = () => {
    setOpenCommentDialog(false);
    setShowWaitSpinner(false);
    setFormActionDetails({
      comment: "",
      signDoc: null,
      signType: SignTypeValues.ATTACH_SIGNED_DOCUMENT,
    });
  };

  const handleApproveClick = async () => {
    if (inspectionData.sectionsVerified?.length != inspectionData.selectedForm.template.length) {
      dispatch(
        showToastNotification({
          content: t("Please verify all sections before approving the form") as TranslatedString,
          type: TOAST_TYPE_ERROR,
        }),
      );
    } else {
      setShowWaitSpinner(true);
      const res = await saveInspectionData("approve");
      if (res.data.status) {
        showToastAndRedirect("Form Approved Successfully");
        setShowWaitSpinner(false);
      } else {
        dispatch(
          showToastNotification({
            content: res.data.errorMessage,
            type: TOAST_TYPE_ERROR,
          }),
        );
        setShowWaitSpinner(false);
      }
    }
  };

  function verifyAllState() {
    let isVerifyAllDisabled = true;
    _.get(inspectionData, "selectedForm.template", []).forEach((section: any) => {
      const secPermission = getSectionPermission({
        section,
        inspectionData,
        userId: userDetails.id,
        type: "Verify",
      });
      if (secPermission && inspectionData.sectionsVerified.length < inspectionData.selectedForm.template.length) {
        isVerifyAllDisabled = false;
      }
    });
    return isVerifyAllDisabled;
  }

  const handleSaveCmntClick = async () => {
    if (openCommentDialog.source == "reject") {
      setShowWaitSpinner(true);
      const res = await saveInspectionData("reject");
      if (res.data.status) {
        showToastAndRedirect(res.data.message);
        setShowWaitSpinner(false);
      } else {
        dispatch(
          showToastNotification({
            content: res.data.errorMessage,
            type: TOAST_TYPE_ERROR,
          }),
        );
        setShowWaitSpinner(false);
      }
    } else if (openCommentDialog.source == "approve") {
      handleApproveClick();
    } else if (openCommentDialog.source == "rollBack") {
      handleRollBack();
    }
  };

  function onClickWarningModalConfirm({ source, showWarningModal }: { source: any; showWarningModal: any }) {
    if (source == "verify") {
      verifySection([showWarningModal.data._id]);
    }
    if (source == "modify") {
      setModifySection((prev: any) => [...prev, showWarningModal.data._id]);
    }
    if (source == "verifyAll") {
      const tempSectionIds: any = [];
      inspectionData.selectedForm.template?.map((section: any) => {
        const permission = getSectionPermission({
          section,
          inspectionData,
          userId: userDetails.id,
          type: "Verify",
        });
        if (permission) {
          tempSectionIds.push(section._id);
        }
      });
      verifySection([...tempSectionIds]);
    }
    hideWarningModal();
  }

  const handleShowWarningModal = (event: any, source: any, section: any) => {
    event?.stopPropagation();
    setShowWarningModal({ status: true, source, data: section });
  };
  const hideWarningModal = () => {
    setShowWarningModal({ status: false });
  };

  const handleExportPdf = async () => {
    const formData = {
      formId: inspectionData._id,
      projectId: inspectionData.project._id,
      paperSize: openExportModal.paperSize,
      tableSectionFormat: openExportModal.tableFormat,
    };
    setOpenExportModal({ state: false, paperSize: "A4", tableFormat: "card" });
    exportPdf({
      formId: formData.formId,
      projectId: formData.projectId,
      paperSize: formData.paperSize,
      tableSectionFormat: formData.tableSectionFormat,
      exportType: EXPORT_TYPE.PDF,
    });
  };

  const handleAddTableRowClick = ({ section, sectionIndex }: { section: any; sectionIndex: any }) => {
    const newObjRow: any = {
      rowId: uuid(),
    };
    inspectionData.selectedForm.template[sectionIndex].questionFields.map((field: any) => {
      newObjRow[field._id] = {};
    });
    const modifiedTemplate = [...inspectionData.selectedForm.template];

    modifiedTemplate[sectionIndex].tableDataSource = [...modifiedTemplate[sectionIndex].tableDataSource, newObjRow];

    setInspectionData((prev: any) => ({
      ...prev,
      selectedForm: {
        ...prev.selectedForm,
        template: modifiedTemplate,
      },
    }));

    setEachAnswerToSave({
      tableSectionId: section._id,
      tableSectionDataSource: [...modifiedTemplate[sectionIndex].tableDataSource],
    });
  };

  const handleDeleteTableRow = ({
    section,
    sectionIndex,
    rowIndex,
  }: {
    section: any;
    sectionIndex: any;
    rowIndex: any;
  }) => {
    const modifiedTemplate = [...inspectionData.selectedForm.template];

    const dataSource = modifiedTemplate[sectionIndex].tableDataSource;

    dataSource.splice(rowIndex, 1);

    modifiedTemplate[sectionIndex].tableDataSource = [...dataSource];

    setInspectionData((prev: any) => ({
      ...prev,
      selectedForm: {
        ...prev.selectedForm,
        template: modifiedTemplate,
      },
    }));

    setEachAnswerToSave({
      tableSectionId: section._id,
      tableSectionDataSource: [...dataSource],
    });
  };

  function handleAddUserClick({
    preSelectedUsers,
    handleCustomFieldData,
  }: {
    preSelectedUsers: any[];
    handleCustomFieldData?: HandleCustomFieldData;
  }) {
    const selectedUsers = [...preSelectedUsers];
    if (inspectionData._id) {
      const sectionIndex = showAddUsersModal.sectionIndex;
      const fieldIndex = showAddUsersModal.fieldIndex;
      if (showAddUsersModal.source == formSectionType.FORM) {
        const modifiedTemplate = [...inspectionData.selectedForm.template];
        if (modifiedTemplate[sectionIndex].questionFields[fieldIndex].answer) {
          modifiedTemplate[sectionIndex].questionFields[fieldIndex].answer = {
            ...modifiedTemplate[sectionIndex].questionFields[fieldIndex].answer,
            value: selectedUsers,
          };
        } else {
          modifiedTemplate[sectionIndex].questionFields[fieldIndex].answer = {
            value: selectedUsers,
          };
        }

        setInspectionData((prev: any) => ({
          ...prev,
          selectedForm: {
            ...prev.selectedForm,
            template: modifiedTemplate,
          },
        }));

        setEachAnswerToSave({
          sectionId: modifiedTemplate[sectionIndex]._id,
          questionId: modifiedTemplate[sectionIndex].questionFields[fieldIndex]._id,
          answer: { value: selectedUsers },
        });
      } else {
        const modifiedTemplate = [...inspectionData.selectedForm.template];

        const modifiedTableDataSource = modifiedTemplate[sectionIndex].tableDataSource.map(
          (row: any, index: number) => {
            if (index == showAddUsersModal.tableRowIndex) {
              row[showAddUsersModal.fieldData._id] = {
                createdDate: Date.now(),
                createdBy: userDetails._id,
                value: selectedUsers,
              };
            }
            return row;
          },
        );

        modifiedTemplate[sectionIndex].tableDataSource = modifiedTableDataSource;

        setInspectionData((prev: any) => ({
          ...prev,
          selectedForm: {
            ...prev.selectedForm,
            template: modifiedTemplate,
          },
        }));

        setEachAnswerToSave({
          tableSectionId: modifiedTemplate[sectionIndex]._id,
          tableSectionDataSource: modifiedTableDataSource,
        });
      }
    } else if (handleCustomFieldData) {
      handleCustomFieldData({
        eachField: showAddUsersModal.fieldData,
        answerValue: selectedUsers,
        fieldIndex: showAddUsersModal.fieldIndex,
        sectionIndex: showAddUsersModal.sectionIndex,
        tableRowIndex: showAddUsersModal.tableRowIndex,
        source: showAddUsersModal.source,
      });
    }
  }
  const handleURLModalState = ({
    state,
    sectionIndex = 0,
    eachField = 0,
    tableRowIndex = 0,
    answer = {},
    fieldIndex = 0,
    sectionId,
    source,
    tableRowId,
  }: {
    state: any;
    sectionIndex?: any;
    eachField?: any;
    tableRowIndex?: any;
    answer?: any;
    fieldIndex?: any;
    sectionId?: any;
    source?: any;
    tableRowId?: any;
  }) => {
    setShowUrlModal((prev: any) => ({
      ...prev,
      state,
      sectionIndex,
      eachField,
      tableRowIndex,
      answerValue: answer.value,
      fieldIndex,
      sectionId,
      source,
      uniqueId: tableRowId ? `${tableRowId}${eachField._id}` : eachField._id,
    }));
  };

  const handleGeoLocationModalState = ({
    sectionIndex,
    eachField,
    tableRowIndex,
    answer,
    fieldIndex,
    sectionId,
    source,
    tableRowId,
    state,
  }: {
    sectionIndex: any;
    eachField: any;
    tableRowIndex: any;
    answer: any;
    fieldIndex: any;
    sectionId: any;
    source: any;
    tableRowId: any;
    state: any;
  }) => {
    setShowGeoLocationModal({
      sectionIndex,
      eachField,
      tableRowIndex,
      answer,
      fieldIndex,
      sectionId,
      source,
      tableRowId,
      state,
      uniqueId: tableRowId ? `${tableRowId}${eachField._id}` : eachField._id,
    });
  };

  const handleSaveUrlData = (handleCustomFieldData: any, URLData: any) => {
    if (!URLData.displayText || !URLData.URL) {
      const field = !URLData.displayText ? "Display Text" : "URL";
      dispatch(
        showToastNotification({
          content: t("{{field}} is Missing", { field }) as TranslatedString,
          type: TOAST_TYPE_ERROR,
        }),
      );
      return;
    }
    handleURLModalState({ state: false });
    const answerValue = {
      ...URLData,
    };
    const { eachField, sectionIndex, tableRowIndex, fieldIndex, sectionId, source } = showUrlModal;
    const { _id } = eachField;

    if (handleCustomFieldData) {
      handleCustomFieldData({
        eachField: showUrlModal.eachField,
        answerValue,
        fieldIndex: showUrlModal.fieldIndex,
        sectionIndex: showUrlModal.sectionIndex,
        tableRowIndex: showUrlModal.tableRowIndex,
        source: showUrlModal.source,
      });
    } else if (inspectionData._id) {
      if (source == formSectionType.TABLE_SECTION) {
        setInspectionData((prev: any) => {
          const modifiedTemplate = prev.selectedForm.template;
          const modifiedTableDataSource = modifiedTemplate[sectionIndex].tableDataSource.map(
            (row: any, index: number) => {
              if (index == tableRowIndex) {
                row[_id] = {
                  createdDate: Date.now(),
                  createdBy: userDetails._id,
                  value: answerValue,
                };
              }
              return row;
            },
          );
          modifiedTemplate[sectionIndex].tableDataSource = modifiedTableDataSource;

          setEachAnswerToSave({
            tableSectionId: sectionId,
            tableSectionDataSource: modifiedTableDataSource,
          });

          return {
            ...prev,
            selectedForm: {
              ...prev.selectedForm,
              template: modifiedTemplate,
            },
          };
        });
      } else {
        setInspectionData((prev: any) => {
          const modifiedTemplate = prev.selectedForm.template;
          modifiedTemplate[sectionIndex].questionFields[fieldIndex].answer = {
            value: answerValue,
          };
          return {
            ...prev,
            selectedForm: {
              ...prev.selectedForm,
              template: modifiedTemplate,
            },
          };
        });

        setEachAnswerToSave({
          sectionId,
          questionId: _id,
          answer: { value: answerValue },
        });
      }
    }
  };

  function checkWhichSectionsExist({
    section,
    sectionIndex,
    contractDetails,
  }: {
    section: any;
    sectionIndex: any;
    contractDetails: any;
  }) {
    const permission: any = getUserPermissionForForm(inspectionData, userDetails.id, sectionIndex);

    let isCurrentUserAllowed = permission;
    const customModuleSectionHeadings = customModules.map((module: any) => module.name) || [];
    const customModuleSectionCode = customModules.map((module: any) => module.resourceType) || [];
    if (inspectionData.contractId) {
      isCurrentUserAllowed = permission && contractDetails.userPermissions?.includes(RESOURCE_MODIFY.id);
    }

    return {
      isCurrentUserAllowed,
      doesQuantityExist: section.sectionCode == presetSectionsCodeObject.SECTION_TYPE_QUANTITY,
      doesTaskExist: section.sectionCode == presetSectionsCodeObject.SECTION_TYPE_TASK,
      doesReferenceExist: section.sectionCode == presetSectionsCodeObject.SECTION_TYPE_REFERENCE,
      doesLinkedFormExist:
        [
          ...customModuleSectionHeadings,
          presetSectionsObject.SECTION_TYPE_INSPECTION,
          presetSectionsObject.SECTION_TYPE_BILLS,
          presetSectionsObject.SECTION_TYPE_CHANGE_ORDERS,
          presetSectionsObject.SECTION_TYPE_PROGRESS_UPDATES,
        ].includes(section.sectionHeading) &&
        [
          ...customModuleSectionCode,
          presetSectionsCodeObject.SECTION_TYPE_BILLS,
          presetSectionsCodeObject.SECTION_TYPE_CHANGE_ORDERS,
          presetSectionsCodeObject.SECTION_TYPE_INSPECTION,
          presetSectionsCodeObject.SECTION_TYPE_PROGRESS_UPDATES,
        ].includes(section.sectionCode),
      doesSectionTypeFormsExist: section.sectionCode == presetSectionsCodeObject.SECTION_TYPE_FORM,
      doesMilestoneExist: section.sectionCode == presetSectionsCodeObject.SECTION_TYPE_MILESTONE,
      doesWbsItemsExist: section.sectionCode == presetSectionsCodeObject.SECTION_TYPE_WBS_ITEMS,
      doesSummaryOfChangesExist: section.sectionCode == presetSectionsCodeObject.SECTION_TYPE_SUMMARY_OF_CHANGES,
      doesReviewsExist: section.sectionCode == presetSectionsCodeObject.SECTION_TYPE_REVIEWS,
      doesTableSectionExist: section.sectionCode === presetSectionsCodeObject.SECTION_TYPE_TABLE_SECTION,
    };
  }

  const getTableSectionShowAnsLogic = (section: any, field: any) => {
    const isFinalState = inspectionData.isApproved || inspectionData.isRejected || inspectionData.isArchived?.status;

    if (isFinalState) return true;

    const hasModifyPermission = getSectionPermission({
      section,
      inspectionData,
      userId: userDetails.id,
      type: "Modify",
    });

    const isSectionLocked = !hasModifyPermission || !modifySection.includes(section._id);

    const isPredefinedAllowed =
      !section.allowPreDefineRowValues ||
      (section.allowPreDefineRowValues &&
        (!field.allowPreDefinedColValues || (field.allowPreDefinedColValues && section.allowEditPreDefineRowInForm)));

    return isSectionLocked && !isPredefinedAllowed;
  };

  const getNormalSectionShowAnsLogic = (section: any, field: any) => {
    const isFinalState = inspectionData.isApproved || inspectionData.isRejected || inspectionData.isArchived?.status;

    if (isFinalState) return true;

    const isPredefinedLocked = field.allowPredefinedVal && !field.allowEditingOfPredefinedVal;

    if (isPredefinedLocked) return true;

    const canModifySection =
      getSectionPermission({
        section,
        inspectionData,
        userId: userDetails.id,
        type: "Modify",
      }) && !modifySection.includes(section._id);

    return canModifySection;
  };

  return {
    inspectionData,
    isFileUploading,
    setInspectionData,
    showAttachmentModal,
    setShowAttachmentModal,
    attachmentModalOpenedFor,
    setAttachmentModalOpenedFor,
    sideBarTaskDetails,
    setSideBarTaskDetails,
    eachAnswerToSave,
    setEachAnswerToSave,
    answerSaved,
    setAnswerSaved,
    lastSaved,
    setLastSaved,
    openCommentDialog,
    setOpenCommentDialog,
    formActionDetails,
    setFormActionDetails,
    accordionExpandedState,
    setAccordionExpandedState,
    showSideBar,
    setShowSideBar,
    showAddUsersModal,
    setShowAddUsersModal,
    showWarningModal,
    setShowWarningModal,
    modifySection,
    setModifySection,
    sideBarAccordions,
    setInitialData,
    handleInputChange,
    setEachAnswer,
    // dateFieldFocused,
    openAddUserModal,
    closeUsersModal,
    saveInspectionData,
    removeUserFromList,
    verifySection,
    handleAttachmentClick,
    closeAttachmentModal,
    handleModifyCancel,
    verifyToggleStatus,
    handleFormActionClick,
    beforeOpenActionDropdown,
    handleFormStateChange,
    handleCollapseAll,
    handleExpandAll,
    handleAccStateChange,
    showToastAndRedirect,
    handleSubmitClick,
    handleFormSubmission,
    closeCommentDialog,
    handleShowWarningModal,
    hideWarningModal,
    userDetails,
    projectData,
    handleSaveCmntClick,
    teamData,
    setTeamData,
    loactionData,
    setLoactionData,
    setIsDataFetched,
    isDataFetched,
    openAddedUserModalInMobile,
    onClickWarningModalConfirm,
    handleFileUploadChange,
    handleRemoveUploadedFile,
    setTableSectionConfig,
    tableSectionConfig,
    handleExportPdf,
    actionBtnDisabled,
    formObject,
    // addValidationToInputFields,
    handleDeleteTableRow,
    handleAddTableRowClick,
    handleAddUserClick,
    getTeamDataForMobile,
    getLocationForMobile,
    showWaitSpinner,
    selectSignType,
    saveEditedImage,
    verifyAllState,
    imageFieldSelectedIndex,
    setImageFieldSelectedIndex,
    customModules,
    formValidator,
    setOpenExportModal,
    openExportModal,
    handleURLModalState,
    showUrlModal,
    setShowUrlModal,
    handleSaveUrlData,
    handleChangeAnswer,
    ActionItems,
    showGeoLocationModal,
    setShowGeoLocationModal,
    handleGeoLocationModalState,
    checkWhichSectionsExist,
    getTableSectionShowAnsLogic,
    getNormalSectionShowAnsLogic,
    commentSaveDisabledState,
    levelEditModal,
    setLevelEditModal,
  };
};
export default useForms;
